module.exports = [
 {
  "start": 83,
  "end": 1750,
  "text": "To watch \"4th Floor To Mildness\", "
 },
 {
  "start": 1875,
  "end": 4417,
  "text": "the visitors are laying down on their backs "
 },
 {
  "start": 4583,
  "end": 6583,
  "text": "on one of 18 beds scattered "
 },
 {
  "start": 6708,
  "end": 8708,
  "text": "throughout the exhibition space. "
 },
 {
  "start": 8917,
  "end": 10291,
  "text": "The beds are second-hand, "
 },
 {
  "start": 10375,
  "end": 12375,
  "text": "but the covers are newly produced "
 },
 {
  "start": 12458,
  "end": 13834,
  "text": "with this coolest fabric "
 },
 {
  "start": 13875,
  "end": 15959,
  "text": "of recycled pet bottles."
 },
 {
  "start": 16291,
  "end": 17917,
  "text": "The visitors look up at two "
 },
 {
  "start": 17959,
  "end": 20000,
  "text": "amorphous screens suspended "
 },
 {
  "start": 20083,
  "end": 21125,
  "text": "from the ceiling "
 },
 {
  "start": 21542,
  "end": 23417,
  "text": "how do we perceive differently "
 },
 {
  "start": 23625,
  "end": 25000,
  "text": "when muscles can relax "
 },
 {
  "start": 25083,
  "end": 26417,
  "text": "and the spine does not have "
 },
 {
  "start": 26500,
  "end": 28667,
  "text": "to hold the head against gravity?"
 },
 {
  "start": 29083,
  "end": 31291,
  "text": "For the production of “4th Floor To Mildness” "
 },
 {
  "start": 31333,
  "end": 34208,
  "text": "I filmed in the underwater of the Old Rhine. "
 },
 {
  "start": 34458,
  "end": 36166,
  "text": "The camera work takes account "
 },
 {
  "start": 36250,
  "end": 38125,
  "text": "of the final viewing direction "
 },
 {
  "start": 38250,
  "end": 42542,
  "text": "and is avoiding horizontal movements; "
 },
 {
  "start": 42667,
  "end": 44125,
  "text": "that means my camera movements "
 },
 {
  "start": 44208,
  "end": 46458,
  "text": "are solely 'climbing' up towards "
 },
 {
  "start": 46500,
  "end": 49083,
  "text": "the sun and pushing or sinking down "
 },
 {
  "start": 49166,
  "end": 50458,
  "text": "through the mud. "
 },
 {
  "start": 50708,
  "end": 52959,
  "text": "The work itself describes the fantasy "
 },
 {
  "start": 53083,
  "end": 56166,
  "text": "of being an organic plant ourselves "
 },
 {
  "start": 56208,
  "end": 58834,
  "text": "and simulates our dissolution into water, "
 },
 {
  "start": 58917,
  "end": 60959,
  "text": "slime, molecules and atoms. "
 },
 {
  "start": 61083,
  "end": 62917,
  "text": "The title of the work initially "
 },
 {
  "start": 62959,
  "end": 64250,
  "text": "included the subtitle: "
 },
 {
  "start": 64375,
  "end": 67041,
  "text": "Monet’s Nymphéas from the other side."
 },
 {
  "start": 67708,
  "end": 69834,
  "text": "My goal is that the installation shows "
 },
 {
  "start": 69959,
  "end": 72667,
  "text": "respect towards everyone around us"
 },
 {
  "start": 72792,
  "end": 74333,
  "text": "It is important to me that people "
 },
 {
  "start": 74417,
  "end": 76208,
  "text": "pay attention to the other, "
 },
 {
  "start": 76333,
  "end": 78458,
  "text": "that we come together with strangers, "
 },
 {
  "start": 78583,
  "end": 81834,
  "text": "laying in beds and taking each other seriously "
 },
 {
  "start": 82125,
  "end": 83583,
  "text": "taking off your shoes, "
 },
 {
  "start": 83667,
  "end": 85959,
  "text": "as we kindly ask the visitors to do, "
 },
 {
  "start": 86041,
  "end": 88417,
  "text": "can be understood as a sign of respect "
 },
 {
  "start": 88500,
  "end": 90291,
  "text": "for the next visitor, too."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room9/audio1/09_MCA 4th Floor to Mildness.js